module.exports = __webpack_public_path__ + "img/DOD_T-5000.49fa0db8.webp";